// src/AgriLinkMetaverseLanding.jsx
import React, { useState } from "react";
import AgriMetaverseHeroSection from "./components/AgriMetaverseHeroSection";
import AgriMetaverseStakeholdersGrid from "./components/AgriMetaverseStakeholdersGrid";
import AgriMetaverseMarketplace from "./components/AgriMetaverseMarketplace";
import AgriMetaverseStagedTimeline from "./components/AgriMetaverseStagedTimeline";
import AgriMetaverseAnimatedUniverse from "./components/AgriMetaverseAnimatedUniverse";
import AgriMetaverseMap from "./components/AgriMetaverseMap";

const AgriLinkMetaverseLanding = () => {
  // Dummy "player"
  const [player] = useState({ id: "player1", name: "You" });

  // Dummy marketplace dataset (you’ll replace with real listings later)
  const [selectedListings, setSelectedListings] = useState([
    { id: 1, type: "crop", name: "Tomato", owner: "player1" },
    { id: 2, type: "crop", name: "Potato", owner: "resident1" },
    { id: 3, type: "item", name: "Tractor", owner: "resident2" },
    { id: 4, type: "crop", name: "Wheat", owner: null },
    { id: 5, type: "facility", name: "Warehouse", owner: "resident3" },
  ]);

  // Example handlers
  const handleContact = (listing) => {
    alert(`Contacting owner of ${listing.name}`);
  };

  const handleMakeOffer = (listing, amount) => {
    alert(`Making offer of ₹${amount} for ${listing.name}`);
  };

  return (
    <div className="min-h-screen bg-black px-4 py-6">
      <AgriMetaverseHeroSection />
      <AgriMetaverseAnimatedUniverse />

      {/* Marketplace */}
      <AgriMetaverseMarketplace onSelect={setSelectedListings} />

      {/* Village / Market Map */}
      <AgriMetaverseMap
        rows={6}
        cols={8}
        dataset={selectedListings}
        ownerId={player.id}
        onContact={handleContact}
        onMakeOffer={handleMakeOffer}
      />

      <AgriMetaverseStagedTimeline />

      {/* CTA */}
      <div className="text-center mt-12">
        <button className="bg-green-700 text-white px-6 py-3 rounded-2xl text-lg font-semibold shadow-lg hover:bg-green-800 transition">
          Join Now
        </button>
      </div>
    </div>
  );
};

export default AgriLinkMetaverseLanding;
